import React from 'react';

const FinanceIcon = ({ className = '' }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      x="0"
      y="0"
      viewBox="0 0 496 496"
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M327.448,0c-72.1,0-130.8,58.7-130.8,130.8s58.7,130.9,130.8,130.9s130.8-58.7,130.8-130.8S399.548,0,327.448,0z     M327.548,241.7c-61.2,0-110.9-49.6-110.9-110.8c0,0,0,0,0-0.1c0.1-61.1,49.6-110.7,110.8-110.8c61.2,0,110.9,49.6,110.9,110.8    S388.748,241.7,327.548,241.7z"
              fill="#5c48d3"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M356.848,175.3c0,0,0,0-0.1,0c-17.6,6.8-37.6,2.6-50.9-10.8c-0.2-0.2-0.4-0.6-0.6-0.6h42.2c5.5,0,10-4.5,10-10    s-4.5-10-10-10h-53.7c-1.1-3.6-1.7-7.3-1.8-11h60.8c5.5,0,10-4.5,10-10s-4.5-10-10-10h-57.2c2.3-5.9,5.9-11.3,10.4-15.7    c13.3-13.4,33.3-17.6,50.9-10.8c5.2,2,11-0.6,12.9-5.8c1.9-5.1-0.6-10.9-5.7-12.9c-25-9.6-53.3-3.6-72.2,15.4    c-8.4,8.2-14.4,18.5-17.4,29.9h-10.4c-5.5,0-10,4.5-10,10s4.5,10,10,10h8c0.2,3.7,0.6,7.4,1.3,11h-9.5c-5.5,0-10,4.5-10,10    s4.5,10,10,10h16.6c3.1,5.3,6.9,10.3,11.2,14.7c18.9,19,47.3,25,72.3,15.3c5.2-2,7.7-7.8,5.8-12.9    C367.748,175.9,361.948,173.4,356.848,175.3z"
              fill="#5c48d3"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M479.048,302.4c-0.2-0.5-0.5-0.9-0.8-1.3c-12.9-15.9-36.2-18.3-52.2-5.4c-20,16.3-49.1,39.8-68,55.1    c-13.3,10.7-29.7,16.8-46.8,17.4l-51.2,1.7c-2.1,0.1-4-1-5.1-2.7l-5.7-9.8c-1-1.6-1.1-3.5-0.3-5.2c0.8-1.7,2.3-2.9,4.1-3.2    l52.9-10c18.6-3.5,31.6-21.1,29.5-40.2c-2-18.4-17.6-32.2-36-32.2c-0.5,0-1.1,0-1.8,0l-70.7-2.9c-28.2-1-52.4,4.4-80.7,18.1    l-37,17.9c-5.2-10.8-16.1-17.7-28.1-17.7h-40.9c-17.1-0.1-31,13.7-31.1,30.8v152.3c0.1,17.1,14,30.9,31.1,30.9h40.9    c17.1,0,30.9-13.8,31-30.9v-10.3l39.3-7.2c12.7-1.9,20.7-2.6,34.2-2l107.5,5c38.7,1.7,76.6-11.1,106.3-35.9l74.5-61.8l0.1-0.1    C488.948,340.1,491.148,317.8,479.048,302.4z M92.148,465.1c0,6-4.9,10.9-10.9,10.9h-41.2c-6,0-10.9-4.9-10.9-10.9V312.9    c0-6,4.9-10.9,10.9-10.9h41.2c6,0,10.9,4.9,10.9,10.9V465.1z M461.148,337.5l-74.4,61.7c-25.9,21.6-59,32.7-92.7,31.3l-107.5-5    c-15.1-0.7-24.3,0.2-38.2,2.2c-0.1,0-0.2,0-0.3,0.1l-35.9,6.6v-114l42.8-20.7c25.2-12.2,46.5-17,71.2-16.1l71.2,2.9    c0.4,0,0.9,0,1.3,0c0.1,0,0.5,0,0.8,0c8.2,0.1,15.2,6.2,16.2,14.4c1,8.6-4.8,16.6-13.3,18.3l-52.9,10c-13.9,2.6-23,16.1-20.4,30    c0.6,2.9,1.6,5.7,3.1,8.2l5.7,9.7c4.8,8.1,13.6,12.9,23,12.6l51.2-1.7c21.4-0.8,42-8.5,58.7-21.8c18.9-15.3,48.1-38.8,68.1-55.1    c7.2-5.6,17.5-4.7,23.6,2.1c0.2,0.4,0.5,0.8,0.8,1.2C468.948,321.3,468.048,331.7,461.148,337.5z"
              fill="#5c48d3"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
      </g>
    </svg>
  );
};
export default FinanceIcon;
